//プロフィール画像アップロードcomponent
import React, {Component} from 'react';
import FileBase64 from 'react-file-base64';
import { updateProfilePhoto } from './firebase'

import './css/topVisitor1.css';
import './css/newflow5.css';


export default class Photoupdate extends Component {
	constructor(props) {
		super(props)
		this.state = {
			newImage:'',
			oldImage:''
		}
	}

	componentDidMount = () => {
		this.getNewImage()
		this.getOldImage()
		let inputFile = document.querySelector('input[type=file]')
		if(inputFile) inputFile.classList.add('fileup')
	}	


	getNewImage = () => {
		let newImage = this.props.user.hasOwnProperty('updatePhoto') ? this.props.user.updatePhoto : ''
		this.setState({newImage:newImage})
	}

	getOldImage = () => {
		if(!this.props.user) return
		if (this.props.user.facebookId) {
			this.setState({oldImage:'https://graph.facebook.com/' + this.props.user.facebookId + '/picture?width=250&height=250'})
		} else {
			this.setState({oldImage:'/img/common/m-profile-img@2x.png'})
		}
	}

	setImage = () => {
		const {
			newImage,
			oldImage
		} = this.state
		return newImage ? newImage : oldImage;
	}

	cancel = (e) => {
		e.preventDefault()
		// 表示切り替え
		this.props.changePhoto(false)
	}
	update = (e) => {
		e.preventDefault()
		//console.log('UODATE')
		const { newImage } = this.state
		const { user } = this.props

		//console.log(newImage,user.uid)
		if(user.uid) {
			updateProfilePhoto(newImage,user.uid)
			// 表示切り替え
			this.props.changePhoto(false)
		}

	}

	fileupClick = () => {
		let inputFile = document.querySelector('input[type=file]')		
		inputFile.click()
	}

	getFiles = (e) => {
		let _this = this
		let files = e;

    	let img_base64 = files.base64.toString();

    	let newImage = new Image()
    	newImage.src = img_base64

	    let size = 250;
	    let canvas = document.createElement('canvas');
	    let context = canvas.getContext('2d');
	    canvas.width = size
	    canvas.height = size
	    canvas.style.display = 'none'

    	newImage.addEventListener('load',function(){
    		//console.log(this.width , this.height)
           	let width
           	let height
           	let offsetX
           	let offsetY;
	        if (this.width > this.height) {
	            height = size;
	            width = this.width * (size / this.height);
	            offsetX = -(width - size) / 2;
	            offsetY = 0;
	        } else {
	            width = size;
	            height = this.height * (size / this.width);
	            offsetY = -(height - size) / 2;
	            offsetX = 0;
	        }
	        context.drawImage(this, offsetX, offsetY, width, height);
	        //console.log(canvas.toDataURL())

	    	_this.setState({newImage: canvas.toDataURL()})		
    	},!1)
	}

	render() {
		return (
    		<div className="content-top">			
				<div className="update-photo">
					<h2 className="subtitle">プロフィール写真を変更</h2>
					<div className="profile-image block-photo">
						<span>
							<img src={this.setImage()} alt="" />
						</span>
 						<div className="overlay-photo">
	                      <img className="icon-camera" alt="" src="/img/common/edit-image.svg" onClick={this.fileupClick} />
	                      <FileBase64 multiple={ false } onDone={ this.getFiles } />
	                    </div>						
					</div>
					<div className="photo-notification">
						<p>ご本人様の証明書として相応しい写真を設定してください。</p>
					</div>
					<div className="update-photo-btns">
						<a onClick={this.cancel} className="update-photo-btns-cancel">キャンセル</a>
						<a onClick={this.update} className="update-photo-btns-update">保存</a>
					</div>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/photoupdate.js